import { render } from "./ExportChannelsPage.vue?vue&type=template&id=439d657c&scoped=true"
import script from "./ExportChannelsPage.vue?vue&type=script&lang=js"
export * from "./ExportChannelsPage.vue?vue&type=script&lang=js"

import "./ExportChannelsPage.vue?vue&type=style&index=0&id=439d657c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439d657c"]])

export default __exports__